import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import { ALL_APPROVED_ID } from "helpers/skuQualificationHelpers";
import useGlobalContext from "hooks/globalData";
import React from "react";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  ListRequestOfBaseFilter,
  ListResponseOfState,
  State,
} from "services/KnowfullyAdminClient";

type SelectStateProps = Omit<
  AutocompleteWithQueryProps<State>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectState = ({ ...rest }: SelectStateProps) => {
  const { formatMessage: t } = useIntl();
  const { stateService } = useGlobalContext();

  const fetchedStates = useQuery<ListResponseOfState>(
    ["state"],
    () =>
      stateService.getStates(
        ListRequestOfBaseFilter.fromJS({ sortField: "stateName" })
      ),
    {
      onSuccess: (data) => {
        if (data?.data) {
          for (let state of data.data) {
            state.stateName = `${state.stateName!} (${state.name!})`;
          }

          data.data.unshift(
            new State({
              id: ALL_APPROVED_ID,
              stateName: t({ id: "allApprovedStatesLabel" }),
            })
          );
        }
      },
    }
  );

  const renderOption = (props: React.HTMLAttributes<HTMLLIElement>, option: State) => {
    if (option.id === ALL_APPROVED_ID) {
      return <li {...props}><b>{option.stateName}</b></li>;
    }

    return <li {...props}>{option.stateName}</li>;
  };

  return (
    <AutocompleteWithQuery
      {...rest}
      labelField="stateName"
      fetchedData={fetchedStates}
      renderOption={renderOption}
      failMessage={t({ id: "selectStatesFetchFailed" })}
    />
  );
};

export default SelectState;
